/**
 * Select2 Albanian translation.
 */
(function ($) {
	"use strict";

	$.fn.select2.locales['al'] = {
		formatMatches: function (matches) { if (matches === 1) { return "Një rezultat është i disponueshëm, shtypni enter për ta zgjedhur atë."; } return matches + " rezultate janë të disponueshme, përdorni tastet e shigjetave lart e poshtë për të lundruar."; },
		formatNoMatches: function () { return "Nuk u gjet asnjë ndeshje"; },
		formatInputTooShort: function (input, min) { var n = min - input.length; return "Ju lutemi shkruani " + n + " ose më shumë karaktere" ; },
		formatInputTooLong: function (input, max) { var n = input.length - max; return "Ju lutemi fshini  " + n + " karaktere"; },
		formatSelectionTooBig: function (limit) { return "Mund të zgjidhni vetëm " + limit + " artikull"; },
		formatLoadMore: function (pageNumber) { return "Duke ngarkuar më shumë rezultate…"; },
		formatSearching: function () { return "Duke kërkuar…"; }
	};

	$.extend($.fn.select2.defaults, $.fn.select2.locales['al']);
})(jQuery);
